import * as ActionTypes from '../actionTypes';
import { getAPI, putAPI, postAPI, getWithoutOverride, postWithoutOverride } from '../api';
import { getCurrentCompanyId, signoutWhenExpiredToken } from '../../Lib/Utils';
import Config from 'Config';
import { useGetUsers } from 'Backend/users/getUsers';

export function getUserInfo(type) {
    return async (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch({
                type: ActionTypes.STARTING_GET_USER_DETAILS,
            });

            try {
                let action;
                const CompanyId = getCurrentCompanyId();
                if (type) {
                    action = `/users/details?type=${type}&CompanyId=${CompanyId}`;
                } else {
                    action = `/users/details?CompanyId=${CompanyId}`;
                }

                const res = await getAPI(action);
                if (res.success) {
                    dispatch({
                        type: ActionTypes.COMPLETE_GET_USER_DETAILS,
                        payload: {
                            user: res.user || {},
                            company: res.company || {},
                        },
                    });
                }
                return resolve(res || {});
            } catch (err) {
                dispatch({
                    type: ActionTypes.FAILED_GET_USER_DETAILS,
                });
                return reject(err);
            }
        });
    };
}

export function updateUser(params) {
    return async (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch({
                type: ActionTypes.STARTING_UPDATE_USER,
            });

            try {
                params.CompanyId = getCurrentCompanyId();
                const res = await putAPI('/users', params);
                dispatch({
                    type: ActionTypes.COMPLETE_UPDATE_USER,
                    payload: res,
                });

                return resolve(res);
            } catch (err) {
                dispatch({
                    type: ActionTypes.FAILED_UPDATE_USER,
                });

                return reject(err);
            }
        });
    };
}

export function sendInviteUser(params) {
    return async (dispatch) => {
        return new Promise(async (resolve) => {
            try {
                params.CompanyId = getCurrentCompanyId();
                const res = await postWithoutOverride(`${Config.invites_api}/invites`, params, null, true);
                return resolve(res);
            } catch {
                return resolve({});
            }
        });
    };
}

/** @deprecated Use {@link useGetUsers} */
export function getUsers() {
    return async (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch({
                type: ActionTypes.STARTING_GET_USER_LIST,
            });

            try {
                const CompanyId = getCurrentCompanyId();
                const res = await getWithoutOverride(
                    `${Config.company_api}/companies/list?CompanyId=${CompanyId}`,
                    {},
                    null,
                    true,
                    true
                );

                const { data } = res;
                dispatch({
                    type: ActionTypes.COMPLETE_GET_USER_LIST,
                    payload: data,
                });
                return resolve(data);
            } catch (err) {
                await signoutWhenExpiredToken();
                dispatch({
                    type: ActionTypes.FAILED_GET_USER_LIST,
                });
                return reject(err);
            }
        });
    };
}

export function getInvites() {
    return async (dispatch) => {
        return new Promise(async (resolve, reject) => {
            try {
                const CompanyId = getCurrentCompanyId();
                const update = await getWithoutOverride(
                    `${Config.invites_api}/invites/company?CompanyId=${CompanyId}`,
                    null,
                    null,
                    true
                );
                dispatch({
                    type: ActionTypes.COMPLETE_GET_INVITE_LIST,
                    payload: update.data,
                });
                return resolve(update.data);
            } catch (err) {
                await signoutWhenExpiredToken();
                return reject(err);
            }
        });
    };
}

export function updateReferralStatus(referralStatus) {
    return {
        type: ActionTypes.UPDATE_REFERRAL_STATUS,
        payload: referralStatus,
    };
}
